var exports = {
  "zr": "x93eb46d8--d30c23--root",
  "bS": "x93eb46d8--d30c23--nav-row",
  "By": "x93eb46d8--d30c23--nav-button",
};

module.exports = exports;
